import React, { useEffect, useState } from "react";
import { apiClient } from "../../../apiclient/apiclient";
import OrderCard from "./OrderCard";
import { ArrowLeft, Contact } from "lucide-react";
import PageHeader from "../../../components/PageHeader";
import { useNavigate } from "react-router-dom";
import Loader from "../../../components/Loader";
const ShippedOrders = () => {
  const navigate = useNavigate();
  const [orders, setOrders] = useState([]);
 const [loading, setLoading] = useState(true);
 const loadOrders = async () => {
  try {
    setLoading(true);

    const res = await apiClient.get("/all-order?status=shipped");

    //console.log("Delivered API response:", res.data); // 🔎 debug

    setOrders(res.data.data || []);
  } catch (error) {
    console.error("Error loading shipped orders", error);
    setOrders([]);
  } finally {
    setLoading(false); // ✅ VERY IMPORTANT
  }
};


  useEffect(() => { loadOrders(); }, []);

  return (
    <div className="">

       <PageHeader
  title="Shipped Orders"
  role="agent"
  subtitle="Orders that have been shipped"
  variant="orange"   // same gradient you liked
  leftContent={
    <button onClick={() => navigate(-1)}>
      <ArrowLeft size={22} />
    </button>
  }
/>


     {loading ? (
  <Loader text="Loading shipped orders..." />
) : orders.length === 0 ? (
  <p className="text-gray-500 text-center py-6">
    No shipped orders
  </p>
) : (
  <div className="space-y-4 p-3">
    {orders.map((order) => (
      <OrderCard
        key={order._id}
        order={order}
        reload={loadOrders}
      />
    ))}
  </div>
)}
    </div>
  );
};

export default ShippedOrders;
